var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.37 197.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m131.25,137.88h-65.64c-2.85,0-5.16-2.31-5.16-5.16s2.31-5.16,5.16-5.16h65.64c2.85,0,5.16,2.31,5.16,5.16s-2.31,5.16-5.16,5.16Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 62.4,
    cy: 78.34,
    r: 11.53,
    transform: "translate(-2.05 1.67) rotate(-1.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.97,
    cy: 78.34,
    r: 11.53
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m98.69,197.37C44.27,197.37,0,153.1,0,98.69S44.27,0,98.69,0s98.69,44.27,98.69,98.69-44.27,98.69-98.69,98.69Zm0-187.05C49.96,10.32,10.32,49.96,10.32,98.69s39.64,88.36,88.36,88.36,88.36-39.64,88.36-88.36S147.41,10.32,98.69,10.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Black);
export default __webpack_public_path__ + "static/media/3Black.6513835ff365ade0c0ab3458ef5593d4.svg";
export { ForwardRef as ReactComponent };